var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 13.3c-.6 0-1 .4-1 1 0 4-3.2 7.2-7.2 7.2s-7.2-3.2-7.2-7.2c0-.6-.4-1-1-1s-1 .4-1 1c0 4.7 3.6 8.7 8.2 9.2v2.9c0 .6.4 1 1 1s1-.4 1-1v-2.9c4.6-.5 8.2-4.4 8.2-9.2 0-.5-.4-1-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.7c2.5 0 4.6-2 4.6-4.6v-.3h-3.1c-.6 0-1-.4-1-1s.4-1 1-1h3.1V9.5h-3.1c-.6 0-1-.4-1-1s.4-1 1-1h3.1v-.3c0-2.5-2-4.6-4.6-4.6s-4.6 2-4.6 4.6v6.9c0 2.5 2.1 4.6 4.6 4.6z"
  })));
};
export default SvgMic;